// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电路(二）",
      "tec": "冯丽",
      "week": "6-13周",
      "add": "教学楼A座319机械"
    },
    {
      "sub": "高等数学基础（一）",
      "tec": "尤福财",
      "week": "6-16,18周",
      "add": "教学楼C座112教务"
    },
    0,
    {
      "sub": "就业创业指导",
      "tec": "赵明明谢芳",
      "week": "11-15周",
      "add": "教学楼D座122新能"
    },
    0
  ],
  "2": [
    {
      "sub": "新能源科学与工程专业导论",
      "tec": "张雪岩",
      "week": "6-17周",
      "add": "教学楼C座304教务"
    },
    {
      "sub": "电路(二）",
      "tec": "冯丽",
      "week": "6-13周",
      "add": "教学楼A座317机械"
    },
    {
      "sub": "热工基础",
      "tec": "项敬岩",
      "week": "6-17周",
      "add": "教学楼D座124新能"
    },
    0,
    {
      "sub": "军事理论",
      "tec": "邓丽丽",
      "week": "6-14周",
      "add": "教学楼B座422能动"
    }
  ],
  "3": [
    {
      "sub": "马克思主义基本原理",
      "tec": "刘君",
      "week": "6-17周",
      "add": "教学楼C座114教务"
    },
    {
      "sub": "基础英语（一）",
      "tec": "曹翠",
      "week": "6-17周",
      "add": "实训楼E座317管理"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "热工基础",
      "tec": "项敬岩",
      "week": "6-17周",
      "add": "教学楼A座317机械"
    },
    {
      "sub": "电路(二）",
      "tec": "冯丽",
      "week": "6-13周",
      "add": "教学楼A座320电力"
    },
    {
      "sub": "高等数学基础（一）",
      "tec": "尤福财",
      "week": "6-16双周",
      "add": "教学楼C座112教务"
    },
    {
      "sub": "形势与政策",
      "tec": "王树平",
      "week": "6-9周",
      "add": "教学楼A座225电力"
    },
    0
  ],
  "5": [
    {
      "sub": "基础英语（一）",
      "tec": "曹翠",
      "week": "6,8,10,12,14,16周",
      "add": "实训楼E座317管理"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "刘君",
      "week": "6-17周",
      "add": "教学楼A座325电力"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
